const host = "https://irey.youmail.jp"
// const host = 'https://ec.irey.jp'
const api_host = `${host}/api`
export default {
  host,
  api_host
}